<template>
  <v-flex xs12>
    <v-layout row wrap fluid>
      <v-flex xs12 offset-md2 md8 text-xs-center>
        <v-card>
          <v-toolbar color="#b6d000" dark>
            <v-toolbar-title>Eredményeim</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-toolbar-items>
              <v-btn
                small
                fab
                dark
                color="mainBlue"
                @click="showModal = !showModal"
                title="Általános információk a pontokról"
              >
                <v-icon>info</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-spacer></v-spacer>

          <v-layout row wrap>
            <v-flex xs4 class="profileResultText">
              <img
                :src="require('@/assets/img/footprint_mod_1.png')"
                class="profilePicture"
              />
              <br />
              <v-chip color="#0077ab" outline>
                {{ allSteps }}
              </v-chip>
            </v-flex>
            <v-flex xs4 class="profileResultText">
              <img
                :src="require('@/assets/img/new_lingron.png')"
                class="profilePicture"
              />
              <br />
              <v-chip color="#0077ab" outline>
                {{ allLingrons }}
              </v-chip>
            </v-flex>
            <v-flex xs4 class="profileResultText">
              <img
                :src="require('@/assets/img/star_shadow.png')"
                class="profilePicture"
              />
              <br />
              <v-chip color="#0077ab" outline>
                {{ allStars }}
              </v-chip>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 offset-md2 md8 mt-3>
        <v-card>
          <v-toolbar color="#b6d000" dark>
            <v-toolbar-title>Előfizetéseim</v-toolbar-title>
          </v-toolbar>

          <v-spacer></v-spacer>

          <v-list two-line subheader>
            <v-list-tile
              avatar
              v-for="(subscription, key) in subscriptions"
              v-bind:key="key"
            >
              <v-list-tile-content>
                <v-list-tile-title class="profileSubscriptionTitle">{{
                  subscription.course.title
                }}</v-list-tile-title>
                <v-list-tile-sub-title
                  >{{ subscription.start_date }} -
                  {{ subscription.expiration_date }}</v-list-tile-sub-title
                >
              </v-list-tile-content>

              <v-list-tile-action>
                <v-chip
                  v-if="subscription.valid"
                  color="#b6d000"
                  text-color="white"
                  >ÉRVÉNYES</v-chip
                >
                <v-chip v-else color="error" text-color="white">LEJÁRT</v-chip>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-card>
      </v-flex>
      <v-flex xs12 offset-md2 md8 mt-3>
        <v-card>
          <v-toolbar color="#b6d000" dark>
            <v-toolbar-title>Statisztika</v-toolbar-title>
          </v-toolbar>

          <v-spacer></v-spacer>

          <div style="max-width: 700px; margin: 0 auto">
            <canvas id="profileChart" width="300" height="300"></canvas>
          </div>
        </v-card>
      </v-flex>

      <v-dialog v-model="loader" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Adatok betöltése folyamatban
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="showModal" width="600">
        <v-card>
          <v-card-title class="headline mainBlue dark text-light" primary-title>
            Pontszámítás menete

            <v-spacer></v-spacer>

            <v-btn color="error" fab small @click="showModal = !showModal">
              <v-icon class="text-light">close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-layout d-flex>
              <v-flex offset-xs1 xs10 mb-1>
                <v-card>
                  <div class="d-flex flex-no-wrap justify-space-between">
                    <div>
                      <v-card-title class="headline"> Lépés </v-card-title>

                      <v-card-subtitle>
                        <p class="p-3">
                          Amikor meghallgatsz egy hanganyagot egy lépéssel
                          közelebb kerülsz a nyelv elsajátításához. Minden
                          megszerzett lépés 1 pontot ér.
                        </p>
                      </v-card-subtitle>
                    </div>

                    <v-avatar class="ma-3" size="125" tile>
                      <v-img
                        :src="require('@/assets/img/footprint_mod_1.png')"
                      ></v-img>
                    </v-avatar>
                  </div>
                </v-card>
              </v-flex>
            </v-layout>

            <v-layout d-flex>
              <v-flex offset-xs1 xs10 mb-1>
                <v-card>
                  <div class="d-flex flex-no-wrap justify-space-between">
                    <div>
                      <v-card-title class="headline"> Lingron </v-card-title>

                      <v-card-subtitle>
                        <p class="p-3">
                          Amikor meghallgattál és gyakoroltál egy nyelvi
                          építőkockát vagyis lingront 1 újabb pontot szerzel.
                        </p>
                      </v-card-subtitle>
                    </div>

                    <v-avatar class="ma-3" size="125" tile>
                      <v-img
                        :src="require('@/assets/img/new_lingron.png')"
                      ></v-img>
                    </v-avatar>
                  </div>
                </v-card>
              </v-flex>
            </v-layout>

            <v-layout d-flex>
              <v-flex offset-xs1 xs10 mb-1>
                <v-card>
                  <div class="d-flex flex-no-wrap justify-space-between">
                    <div>
                      <v-card-title class="headline"> Csillag </v-card-title>

                      <v-card-subtitle>
                        <p class="p-3">
                          Amennyi alkalommal elvégzel egy leckét annyi csillagot
                          kapsz. A csillagok szorzóként vesznek részt a pontok
                          számításában.
                        </p>
                      </v-card-subtitle>
                    </div>

                    <v-avatar class="ma-3" size="125" tile>
                      <v-img
                        :src="require('@/assets/img/star_shadow.png')"
                      ></v-img>
                    </v-avatar>
                  </div>
                </v-card>
              </v-flex>
            </v-layout>

            <v-layout d-flex>
              <v-flex xs12 mt-4 text-center>
                A pontok számítása a következő képlet szerint történik egy
                leckénél: <br />
                <strong>
                  ( lingronból szerzett pontok + lépésekből szerzett pontok ) *
                  a csillagok száma
                </strong>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-flex>
</template>

<script>
import axios from 'axios';
import { Chart } from 'chart.js';

export default {
  components: {
    Chart,
  },
  data: () => ({
    loader: false,
    user: '',
    subscriptions: '',
    showModal: false,
    allStars: '',
    allSteps: '',
    allLingrons: '',
    messageSuccess: {
      show: false,
      message: '',
      timeout: 4500,
    },
    messageError: {
      show: false,
      message: '',
      timeout: 4500,
    },
    chartData: {
      type: 'line',
      data: [],
      options: {
        responsive: true,
        lineTension: 1,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                padding: 0,
              },
            },
          ],
        },
      },
    },
  }),
  methods: {
    getUserData() {
      axios
        .post(this.$store.getters.getApiUrl + '/api/user/profile', {
          token: this.$store.getters.getToken,
        })
        .then((response) => {
          // console.log('profile- resp: ', response.data);
          this.$data.user = response.data.user;
          this.$data.allSteps = response.data.allSteps;
          this.$data.allLingrons = response.data.allLingrons;
          this.$data.allStars = response.data.allStars;
          this.$data.chartData.data = response.data.chartData;
          this.$data.subscriptions = response.data.subscriptions;
          this.createChart();

          var v = this;
          setTimeout(function () {
            v.$data.loader = false;
          }, 500);
        })
        .catch((error) => {
          if (error.length > 0) {
            // console.log('profile- error: ', error);
          }

          var v = this;
          setTimeout(function () {
            v.$data.loader = false;
          }, 1000);
        });
    },
    createChart() {
      const ctx = document.getElementById('profileChart');
      const myChart = new Chart(ctx, {
        type: this.$data.chartData.type,
        data: this.$data.chartData.data,
        options: this.$data.chartData.options,
      });
    },
  },
  created: function () {
    // this.$data.loader = true; //Show the loader
    this.getUserData();
  },
  mounted() {},
};
</script>
